import { Component, EventEmitter, HostBinding, OnInit, Output } from '@angular/core';

import { Router } from '@angular/router';

import { DeviceDetectorService } from 'ngx-device-detector';

import { OtherService } from 'src/app/Service/other.service';

import momentJalaali from 'moment-jalaali';

import axios from 'src/app/Service/axios';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

  selector: 'menu-peysepar',

  templateUrl: './menu-peysepar-component.component.html',

})

export class MenuPeyseparComponentComponent implements OnInit {

  @HostBinding('class') classes = 'MenuItem';

  isDesktop: boolean = false;

  fullName: any = '';

  comapnyName: any = '';

  holidayYear: any;

  @Output() modalMenu = new EventEmitter<any>();

  @Output() holidayData = new EventEmitter<any>();

  constructor(private DeviceDetector: DeviceDetectorService, private otherService: OtherService, private router: Router, private gurdService: GurdServiceService) { }

  ngOnInit(): void {

    // is holiday clicked

    this.otherService.isHolidayClicked$.subscribe((isClicked) => {

      if (isClicked) {

        this.holidayModal()

      }

    });

    this.isDesktop = this.DeviceDetector.isDesktop();

    this.comapnyName = this.gurdService.decrypt(window.localStorage.getItem('companyName')!);

    this.fullName = this.gurdService.decrypt(window.localStorage.getItem('FullName')!);

  }

  async holidayModal() {

    this.holidayYear = momentJalaali().locale('fa').format('jYYYY');

    let model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iYear: this.holidayYear


    }

    let res = JSON.parse((await axios.post(`Holidays_List`, model)).data.toString());

    this.holidayData.emit(res);

    $('#holidaysModal').modal('show');

    var tooltip = $('#map_tooltip');

    tooltip.tooltip('hide');
  }

  close() {

    let tag = document.getElementsByTagName("menu-peysepar") as any;

    tag[0].classList.add('d-none');

    let bgTag = document.getElementById('bg-menu') as any;

    bgTag.classList.add('d-none');

    if (this.isDesktop) {

      $("#test").css("right", "0%");

    }

  }

  clickMethod(name: string) {
    $.confirm({
      title: `آیا از خروج از حساب کاربری اطمینان دارید؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: "تایید",
          btnClass: 'btn-danger',
          keys: ['enter'],
          action: () => {
            this.otherService.removeLocalStorage();
            this.router.navigate(['login']);
            window.location.reload();

          }
        },
        cancel: {
          text: "لغو",
        }
      }
    });
  }

}
